import * as React from 'react';
import { AppContext } from '@contexts/app/AppContext';
import { AppContextData } from '@contexts/app/AppContextData';

export type WithAppContext<A> = {
    appContext: AppContextData;
} & A;

/**
 * provide app context via AppContext
 * @param Component
 */
export function withAppContext<TProps>(Component: React.FC<TProps>): React.FC<WithAppContext<TProps>> {
    const ComponentWithAppContext: React.FC<WithAppContext<TProps>> = props => (
        <AppContext.Provider value={props.appContext}>
            <Component {...props} />
        </AppContext.Provider>
    );

    ComponentWithAppContext.displayName = `${Component.displayName || 'Component'}WithAppContext`;

    return ComponentWithAppContext;
}
